<template>
  <div class="batch-generation-center">
    <!-- 精简侧边栏 -->
    <div class="slim-sidebar">
      <div class="sidebar-middle">
        <div class="nav-item" @click="handleScriptClick" title="脚本">
          <svg class="nav-icon" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
            <path d="M661.653927 850.681606l-598.429465 0L63.224462 166.398798l598.429465 0L661.653927 850.681606zM605.57777 794.633079 605.57777 222.461651 119.313921 222.461651l0 572.172451L605.57777 794.634102" fill="currentColor"></path>
            <path d="M240.774227 366.237195c-15.442714 0-28.009937-12.568247-28.009937-28.051893 0-15.456017 12.567223-28.024264 28.009937-28.024264l252.366751 0c15.496949 0 28.052916 12.568247 28.052916 28.024264 0 15.483646-12.555967 28.051893-28.052916 28.051893L240.774227 366.237195" fill="currentColor"></path>
            <path d="M240.774227 528.002462c-15.442714 0-28.009937-12.56927-28.009937-28.052916 0-15.497972 12.567223-28.05087 28.009937-28.05087l252.366751 0c15.496949 0 28.052916 12.552897 28.052916 28.05087 0 15.482623-12.555967 28.052916-28.052916 28.052916L240.774227 528.002462" fill="currentColor"></path>
            <path d="M240.774227 689.73703c-15.442714 0-28.009937-12.539594-28.009937-28.010961 0-15.495926 12.567223-28.063149 28.009937-28.063149l252.366751 0c15.496949 0 28.052916 12.567223 28.052916 28.063149 0 15.471366-12.555967 28.010961-28.052916 28.010961L240.774227 689.73703" fill="currentColor"></path>
            <path d="M848.279395 867.327728 717.454814 705.59009l0-539.231201 242.974847 0 0 539.231201L848.279395 867.327728zM844.829829 773.906012l59.499116-85.865623L904.328945 222.461651 773.504364 222.461651l0 463.249693L844.829829 773.906012" fill="currentColor"></path>
            <path d="M754.831073 348.274078 754.831073 292.171316 923.055448 292.171316 923.055448 348.274078 754.831073 348.274078Z" fill="currentColor"></path>
          </svg>
          <span class="nav-label">脚本</span>
        </div>
        <div class="nav-item" @click="handleReverseClick" title="反推">
          <svg class="nav-icon" viewBox="0 0 1429 1024" xmlns="http://www.w3.org/2000/svg">
            <path d="M893.45 200.72c-47.147 0-85.61 37.22-85.61 83.54 0 19.714 7.17 37.498 18.75 51.697l-93.33 99.808c-12.82-7.72-27.985-12.407-44.252-12.407-22.746 0-43.425 8.823-59.003 23.298l-89.607-72.926c6.618-11.718 10.34-25.09 10.34-39.014 0-46.044-38.462-83.541-85.61-83.541s-85.608 37.221-85.608 83.541c0 17.646 5.652 33.913 15.164 47.147l-81.336 83.817c-13.51-9.098-30.328-14.2-47.836-14.2-47.147 0-85.609 37.222-85.609 83.542 0 46.044 38.186 83.541 85.61 83.541 47.146 0 85.608-37.221 85.608-83.54 0-18.75-6.617-35.982-17.094-49.63l80.922-83.403c14.2 10.202 31.431 16.267 50.318 16.267 22.332 0 42.46-8.547 57.762-22.332l90.158 73.202c-6.066 11.58-9.65 24.124-9.65 37.91 0 46.044 38.462 83.541 85.609 83.541s85.609-37.221 85.609-83.54c0-20.128-7.72-38.463-19.851-52.8l92.777-99.395c12.82 8.134 28.674 13.097 45.63 13.097 47.148 0 85.61-37.222 85.61-83.542 0.138-46.182-38.324-83.679-85.471-83.679z m0 0" fill="currentColor"></path>
            <path d="M1041.508 0.551H117.592c-56.66 0-102.566 55.143-102.566 111.527v595.816c0 56.66 46.045 102.704 102.704 102.704h303.285v146.404H173.148c-18.06 0-32.81 14.612-32.81 32.81 0 18.059 14.75 32.81 32.81 32.81H986.09c18.06 0 32.81-14.613 32.81-32.81 0-18.06-14.613-32.81-32.81-32.81H738.223V810.736h303.285c56.659 0 102.703-46.045 102.703-102.704V112.215C1144.35 55.695 1098.305 0.551 1041.508 0.551zM672.74 956.864H486.634V810.598h186.107v146.266z m405.85-248.832c0 20.265-16.543 37.084-37.083 37.084H117.592c-20.265 0-37.084-16.543-37.084-37.084V112.353c0-20.265 16.543-37.083 37.084-37.083h924.054c20.265 0 37.083 16.543 37.083 37.083v595.68z m0 0" fill="currentColor"></path>
          </svg>
          <span class="nav-label">反推</span>
        </div>
        <div class="nav-item" @click="handleInspirationClick" title="灵感">
          <span class="iconfont">&#xe600;</span>
          <span class="nav-label">灵感</span>
        </div>
      </div>
      <div class="sidebar-bottom">
        <div class="nav-item" @click="handleShortcutClick" title="快捷键">
          <span class="iconfont">&#xe623;</span>
        </div>
        <div class="nav-item" @click="toggleTheme" title="深色模式">
          <span v-if="theme" class="iconfont">&#xe61c;</span>
          <span v-else class="iconfont">&#xe61d;</span>
        </div>
      </div>
    </div>

    <!-- 内容区域 -->
    <div class="batch-content">
      <!-- 左侧：任务列表 -->
      <div class="task-list-section">
      <div class="section-title">任务列表</div>
      <div class="task-list-body" :class="{ 'has-tasks': displayTaskList.length }">
        <div v-if="displayTaskList.length" class="task-items">
          <div
            v-for="task in displayTaskList"
            :key="task.id"
            class="task-item"
            :class="'is-' + task.status"
          >
            <div class="task-item-head">
              <span class="task-item-name">{{ task.funcLabel }}</span>
              <span class="task-item-status">{{ taskStatusText(task) }}</span>
            </div>
            <div v-if="task._source === 'local' && task.status === 'running'" class="task-item-progress">
              <div class="task-item-progress-bar">
                <div class="task-item-progress-fill" :style="{ width: task.progress + '%' }"></div>
              </div>
              <span class="task-item-progress-num">{{ task.progress }}%</span>
            </div>
            <div v-else class="task-item-meta">
              <span v-if="task.userName" class="task-item-user">{{ task.userName }}</span>
              <span v-if="task.startTime" class="task-item-time">{{ task.startTime }}</span>
            </div>
          </div>
        </div>
        <div v-else class="task-empty-state">
          <div class="task-empty-icon">
            <svg viewBox="0 0 64 64" width="58" height="58" fill="none">
              <rect x="12" y="10" width="40" height="46" rx="5" fill="#dcdce6" />
              <rect x="22" y="6" width="20" height="8" rx="3" fill="#b3ade8" />
              <rect x="20" y="25" width="24" height="3" rx="1.5" fill="#fff" />
              <rect x="20" y="33" width="24" height="3" rx="1.5" fill="#fff" />
              <rect x="20" y="41" width="15" height="3" rx="1.5" fill="#fff" />
            </svg>
          </div>
          <div class="task-empty-text">暂无进行中的任务</div>
          <div class="task-empty-subtext">提交后的任务将在此显示</div>
        </div>
      </div>
    </div>

    <!-- 右侧：需求表 -->
    <div class="requirement-section">
      <div class="section-title">需求表</div>
      <div class="requirement-body">
        <div
          v-for="(card, cardIndex) in requirementCards"
          :key="cardIndex"
          class="req-table"
        >
          <!-- 第一行：编号 + 功能选择 + 定制按钮 -->
          <div class="req-table-header">
            <div class="req-number">{{ cardIndex + 1 }}</div>
            <div class="req-function-select">
              <div
                class="func-select"
                :class="{ 'is-open': card.dropdownOpen }"
                @click.stop="toggleDropdown(cardIndex)"
              >
                <span class="func-select-label">{{ getFunctionLabel(card.selectedFunction) }}</span>
                <i class="func-select-arrow">▾</i>
                <div v-show="card.dropdownOpen" class="func-dropdown-menu">
                  <div
                    v-for="group in functionGroups"
                    :key="group.category"
                    class="func-dropdown-group"
                  >
                    <div class="func-dropdown-group-title">{{ group.category }}</div>
                    <div
                      v-for="fn in group.options"
                      :key="fn.value"
                      class="func-dropdown-item"
                      :class="{ 'is-selected': fn.value === card.selectedFunction }"
                      @click.stop="selectFunction(cardIndex, fn.value)"
                    >{{ fn.label }}</div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 功能后置控件：根据所选功能动态渲染 -->
            <div class="req-func-controls" v-if="hasControls(card.selectedFunction)">
              <!-- 甲型开关 -->
              <div
                v-if="hasControl(card.selectedFunction, 'nailShape')"
                class="fc-toggle"
                :class="{ 'is-on': card.funcParams.nail_replace.nailShapeEnabled }"
                @click.stop="toggleNailShape(cardIndex)"
              >
                <span class="fc-toggle-label">甲型</span>
                <span class="fc-toggle-switch"><span class="fc-toggle-knob"></span></span>
              </div>
              <!-- 甲片风格三选一 -->
              <div v-if="hasControl(card.selectedFunction, 'nailStyle')" class="fc-tabs">
                <span
                  v-for="opt in nailStyleOptions"
                  :key="opt.value"
                  class="fc-tab"
                  :class="{ 'is-active': card.funcParams.nail_replace.selectedStyle === opt.value }"
                  @click.stop="selectNailStyle(cardIndex, opt.value)"
                >{{ opt.label }}</span>
              </div>
              <!-- 产品精修类型三选一 -->
              <div v-if="hasControl(card.selectedFunction, 'retouchType')" class="fc-tabs">
                <span
                  v-for="t in retouchTypeOptions"
                  :key="t"
                  class="fc-tab"
                  :class="{ 'is-active': card.funcParams.product_retouch.selectedType === t }"
                  @click.stop="selectRetouchType(cardIndex, t)"
                >{{ t }}</span>
              </div>
              <!-- 产品精修图像大小 -->
              <div v-if="hasControl(card.selectedFunction, 'retouchResolution')" class="fc-dropdown">
                <span
                  class="fc-dropdown-trigger"
                  :class="{ 'is-open': card.funcParams.product_retouch.resolutionMenuOpen }"
                  @click.stop="toggleFuncMenu(cardIndex, 'product_retouch', 'resolutionMenuOpen')"
                >图像大小：{{ card.funcParams.product_retouch.selectedResolution }}<i class="fc-arrow">▾</i></span>
                <div v-show="card.funcParams.product_retouch.resolutionMenuOpen" class="fc-menu">
                  <div
                    v-for="r in resolutionOptions"
                    :key="r"
                    class="fc-menu-item"
                    :class="{ 'is-active': card.funcParams.product_retouch.selectedResolution === r }"
                    @click.stop="selectFuncResolution(cardIndex, 'product_retouch', r)"
                  >{{ r }}</div>
                </div>
              </div>
              <!-- 产品精修高宽比（特殊类/场景类时出现） -->
              <div
                v-if="hasControl(card.selectedFunction, 'retouchAspectRatio') && (card.funcParams.product_retouch.selectedType === '特殊类' || card.funcParams.product_retouch.selectedType === '场景类')"
                class="fc-dropdown"
              >
                <span
                  class="fc-dropdown-trigger"
                  :class="{ 'is-open': card.funcParams.product_retouch.aspectMenuOpen }"
                  @click.stop="toggleFuncMenu(cardIndex, 'product_retouch', 'aspectMenuOpen')"
                >高宽比：{{ card.funcParams.product_retouch.selectedAspectRatio }}<i class="fc-arrow">▾</i></span>
                <div v-show="card.funcParams.product_retouch.aspectMenuOpen" class="fc-menu">
                  <div
                    v-for="ar in specialAspectRatioOptions"
                    :key="ar"
                    class="fc-menu-item"
                    :class="{ 'is-active': card.funcParams.product_retouch.selectedAspectRatio === ar }"
                    @click.stop="selectAspectRatio(cardIndex, ar)"
                  >{{ ar }}</div>
                </div>
              </div>
              <!-- 多角度：5 个画面角度下拉 -->
              <div v-if="hasControl(card.selectedFunction, 'angles')" class="fc-angles">
                <div
                  v-for="(ang, angIdx) in card.funcParams.multi_angle.selectedAngles"
                  :key="angIdx"
                  class="fc-dropdown"
                >
                  <span
                    class="fc-dropdown-trigger"
                    :class="{ 'is-open': card.funcParams.multi_angle.angleMenusOpen[angIdx] }"
                    @click.stop="toggleAngleMenu(cardIndex, angIdx)"
                  >{{ ang }}<i class="fc-arrow">▾</i></span>
                  <div v-show="card.funcParams.multi_angle.angleMenusOpen[angIdx]" class="fc-menu">
                    <div
                      v-for="ao in angleOptions"
                      :key="ao"
                      class="fc-menu-item"
                      :class="{ 'is-active': ang === ao }"
                      @click.stop="selectAngle(cardIndex, angIdx, ao)"
                    >{{ ao }}</div>
                  </div>
                </div>
              </div>
              <!-- 多角度：高级选项 -->
              <div
                v-if="hasControl(card.selectedFunction, 'advanced')"
                class="fc-btn"
                :class="{ 'is-active': card.funcParams.multi_angle.advancedPanelOpen }"
                @click.stop="toggleAdvanced(cardIndex)"
              >高级选项</div>
              <!-- 无界扩图：上/下/左/右/羽化 -->
              <div v-if="hasControl(card.selectedFunction, 'outpaint')" class="fc-outpaint">
                <label class="fc-num"><span>上</span><input type="number" min="0" max="512" v-model.number="card.funcParams.outpaint.top" @click.stop /></label>
                <label class="fc-num"><span>下</span><input type="number" min="0" max="512" v-model.number="card.funcParams.outpaint.bottom" @click.stop /></label>
                <label class="fc-num"><span>左</span><input type="number" min="0" max="512" v-model.number="card.funcParams.outpaint.left" @click.stop /></label>
                <label class="fc-num"><span>右</span><input type="number" min="0" max="512" v-model.number="card.funcParams.outpaint.right" @click.stop /></label>
                <label class="fc-num"><span>羽化</span><input type="number" min="0" max="512" v-model.number="card.funcParams.outpaint.feather" @click.stop /></label>
              </div>
              <!-- 产品拼接：图像大小 -->
              <div v-if="hasControl(card.selectedFunction, 'spliceResolution')" class="fc-dropdown">
                <span
                  class="fc-dropdown-trigger"
                  :class="{ 'is-open': card.funcParams.product_splice.resolutionMenuOpen }"
                  @click.stop="toggleFuncMenu(cardIndex, 'product_splice', 'resolutionMenuOpen')"
                >图像大小：{{ card.funcParams.product_splice.selectedResolution }}<i class="fc-arrow">▾</i></span>
                <div v-show="card.funcParams.product_splice.resolutionMenuOpen" class="fc-menu">
                  <div
                    v-for="r in resolutionOptions"
                    :key="r"
                    class="fc-menu-item"
                    :class="{ 'is-active': card.funcParams.product_splice.selectedResolution === r }"
                    @click.stop="selectFuncResolution(cardIndex, 'product_splice', r)"
                  >{{ r }}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- 表格主体：列标题行 + 数据行（带竖直分隔线） -->
          <div class="req-table-body">
            <!-- 列标题行（上传列按功能自适应） -->
            <div class="req-row req-row-titles">
              <template v-if="getUploadSpec(card.selectedFunction).mode === 'columns'">
                <div
                  v-for="col in getUploadSpec(card.selectedFunction).columns"
                  :key="col.key"
                  class="req-cell req-cell-upload"
                  :style="uploadColStyle(card.selectedFunction)"
                >{{ col.label }}<span v-if="col.needMask" class="mask-tag">需绘制遮罩</span></div>
              </template>
              <div v-else class="req-cell req-cell-upload req-cell-gallery">{{ getUploadSpec(card.selectedFunction).label }}</div>
              <div class="req-cell req-cell-count">次数</div>
              <div class="req-cell req-cell-output">输出图片</div>
            </div>
            <!-- 数据行 -->
            <div
              v-for="(row, rowIdx) in card.rows"
              :key="rowIdx"
              class="req-row req-row-data"
            >
              <!-- 上传区（按功能自适应：columns 或 gallery） -->
              <template v-if="getUploadSpec(card.selectedFunction).mode === 'columns'">
                <div
                  v-for="col in getUploadSpec(card.selectedFunction).columns"
                  :key="col.key"
                  class="req-cell req-cell-upload"
                  :style="uploadColStyle(card.selectedFunction)"
                >
                  <div
                    class="upload-box"
                    :class="{ 'has-img': row.uploads[col.key] && row.uploads[col.key].url }"
                    @click="handleUpload(cardIndex, rowIdx, col.key)"
                  >
                    <img
                      v-if="row.uploads[col.key] && row.uploads[col.key].url"
                      class="upload-thumb"
                      :src="row.uploads[col.key].url"
                      alt=""
                    />
                    <span v-else class="upload-plus">+</span>
                    <span v-if="col.needMask" class="mask-badge">遮罩</span>
                  </div>
                </div>
              </template>
              <!-- gallery 模式：多图缩略图 + 添加按钮 -->
              <div v-else class="req-cell req-cell-upload req-cell-gallery">
                <div class="gallery-box">
                  <div
                    v-for="(img, gi) in row.galleryImages"
                    :key="gi"
                    class="gallery-thumb"
                  >
                    <img :src="img.url" alt="" />
                    <span class="gallery-remove" @click.stop="removeGalleryImage(cardIndex, rowIdx, gi)">×</span>
                  </div>
                  <div
                    v-if="row.galleryImages.length < getUploadSpec(card.selectedFunction).max"
                    class="upload-box gallery-add"
                    @click="handleGalleryAdd(cardIndex, rowIdx)"
                  >
                    <span class="upload-plus">+</span>
                  </div>
                </div>
              </div>
              <!-- 次数 -->
              <div class="req-cell req-cell-count">
                <div class="count-select">
                  <span
                    class="count-badge"
                    :class="{ 'is-open': row.countMenuOpen }"
                    @click.stop="toggleCountMenu(cardIndex, rowIdx)"
                  >{{ row.count }}次</span>
                  <div v-show="row.countMenuOpen" class="count-menu">
                    <div
                      v-for="opt in countOptions"
                      :key="opt"
                      class="count-menu-item"
                      :class="{ 'is-active': row.count === opt }"
                      @click.stop="selectCount(cardIndex, rowIdx, opt)"
                    >{{ opt }}次</div>
                  </div>
                </div>
              </div>
              <!-- 输出图片 -->
              <div class="req-cell req-cell-output">
                <div v-if="row.status === 'running'" class="output-progress">
                  <div class="output-spinner">
                    <span class="output-spinner-ring"></span>
                    <span class="output-spinner-num">{{ row.progress }}%</span>
                  </div>
                  <span class="output-progress-text">生成中…</span>
                </div>
                <div v-else class="output-gallery">
                  <div
                    v-for="(img, oi) in row.outputImages"
                    :key="oi"
                    class="output-thumb"
                    @click="handleOutputImageClick(row, oi)"
                  >
                    <img :src="img" alt="生成图片" />
                  </div>
                  <span v-if="row.status === 'error' && !row.outputImages.length" class="output-hint output-hint-error">生成失败</span>
                  <span v-else-if="!row.outputImages.length" class="output-hint">暂无输出</span>
                </div>
              </div>
              <!-- 行操作按钮（表格外右侧，垂直居中）：三点圆形按钮 + 悬浮菜单 -->
              <div class="req-row-action" :class="{ 'is-menu-open': row.menuOpen }">
                <div
                  class="row-menu-btn"
                  :class="{ 'is-open': row.menuOpen }"
                  @click.stop="toggleRowMenu(cardIndex, rowIdx)"
                >
                  <span class="dot"></span>
                  <span class="dot"></span>
                  <span class="dot"></span>
                </div>
                <div v-show="row.menuOpen" class="row-menu">
                  <div class="row-menu-item" @click.stop="handleRowDelete(cardIndex, rowIdx)">删除行</div>
                  <div class="row-menu-item" @click.stop="handleRowSave(cardIndex, rowIdx)">保存全部</div>
                  <div class="row-menu-item" @click.stop="handleRowRegenerate(cardIndex, rowIdx)">重新生成</div>
                </div>
              </div>
            </div>
          </div>

          <!-- 悬停气泡：上灰=添加行，下橙=新增需求表 -->
          <div class="req-hover-bubbles" ref="bubbles" :class="{ 'is-visible': card.bubblesVisible }">
            <div class="bubble-btn bubble-gray" title="添加行" @click.stop="addRow(cardIndex)">
              <span>+</span>
            </div>
            <div class="bubble-btn bubble-orange" title="新增需求表" @click.stop="addTable(cardIndex)">
              <span>+</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 底部操作栏：开始批量生成 -->
      <div class="batch-footer">
        <button
          class="batch-start-btn"
          :disabled="batchRunning"
          @click="startBatch"
        >{{ batchRunning ? '生成中…' : '开始批量生成' }}</button>
      </div>
    </div>
    </div>
    <!-- 图片预览组件（隐藏，点击时触发，支持放大缩小） -->
    <el-image
      ref="previewImage"
      style="display: none;"
      :src="previewUrl"
      :preview-src-list="previewList"
      :initial-index="previewStartIndex"
    />
  </div>
</template>

<script>
import { Message } from 'element-ui'
import localStorageUtils from '@/utils/setLocalStorage'
import { getOssClient } from '@/utils/oss'
import { runBatchTask } from '@/utils/AssistantRuquest/batchTasks'
import { getActiveTasks } from '@/api/user'

export default {
  name: 'BatchGenerationCenter',
  data() {
    return {
      theme: true,
      taskList: [],
      localTaskList: [],
      localTaskCounter: 0,
      batchRunning: false,
      previewUrl: '',
      previewList: [],
      previewStartIndex: 0,
      taskPollTimer: null,
      countOptions: [2, 3, 4, 5],
      // 各功能的控件与上传规格配置（驱动“下拉后方控件”与“上传列自适应”）
      functionConfig: {
        nail_replace: {
          controls: ['nailShape', 'nailStyle'],
          uploadSpec: { mode: 'columns', columns: [{ key: 'hand', label: '上传手图' }, { key: 'color', label: '上传色卡' }] }
        },
        product_retouch: {
          controls: ['retouchType', 'retouchResolution', 'retouchAspectRatio'],
          uploadSpec: { mode: 'gallery', label: '上传参考图', max: 14, min: 1 }
        },
        multi_angle: {
          controls: ['angles', 'advanced'],
          uploadSpec: { mode: 'columns', columns: [{ key: 'image', label: '上传产品图' }] }
        },
        light_blend: {
          controls: [],
          uploadSpec: { mode: 'columns', columns: [{ key: 'image', label: '上传产品图' }] }
        },
        universal_migrate: {
          controls: [],
          uploadSpec: { mode: 'columns', columns: [{ key: 'origin', label: '原图', needMask: true }, { key: 'product', label: '产品图' }] }
        },
        partial_redraw: {
          controls: [],
          uploadSpec: { mode: 'columns', columns: [{ key: 'image', label: '上传图片', needMask: true }] }
        },
        outpaint: {
          controls: ['outpaint'],
          uploadSpec: { mode: 'columns', columns: [{ key: 'image', label: '上传图片' }] }
        },
        hd_upscale: {
          controls: [],
          uploadSpec: { mode: 'columns', columns: [{ key: 'image', label: '上传图片' }] }
        },
        product_splice: {
          controls: ['spliceResolution'],
          uploadSpec: { mode: 'gallery', label: '上传图片', max: 10, min: 1 }
        }
      },
      // 控件选项常量（取值与各原功能组件严格一致）
      nailStyleOptions: [
        { label: '常规类', value: 'pure' },
        { label: '果冻类', value: 'jelly' },
        { label: '猫眼类', value: 'maoyan' }
      ],
      retouchTypeOptions: ['常规类', '特殊类', '场景类'],
      resolutionOptions: ['1K', '2K', '4K'],
      specialAspectRatioOptions: ['1:1', '2:3', '3:2', '3:4', '4:3', '4:5', '5:4', '9:16', '16:9', '21:9'],
      angleOptions: ['自定义', '左侧俯视', '右侧俯视', '左侧平视', '右侧平视', '左侧仰视', '右侧仰视', '预设仰视', '预设俯视'],
      angleParamsMap: {
        左侧俯视: { horizontal_angle: 335, vertical_angle: 20, zoom: 5 },
        右侧俯视: { horizontal_angle: 30, vertical_angle: 20, zoom: 5 },
        左侧平视: { horizontal_angle: 335, vertical_angle: 0, zoom: 5 },
        右侧平视: { horizontal_angle: 30, vertical_angle: 0, zoom: 5 },
        左侧仰视: { horizontal_angle: 335, vertical_angle: -15, zoom: 5 },
        右侧仰视: { horizontal_angle: 30, vertical_angle: -15, zoom: 5 },
        预设仰视: { horizontal_angle: 20, vertical_angle: -10, zoom: 5 },
        预设俯视: { horizontal_angle: 345, vertical_angle: 20, zoom: 5 }
      },
      functionGroups: [
        {
          category: '图片',
          options: [
            { label: '替换甲片', value: 'nail_replace' },
            { label: '光影溶图', value: 'light_blend' },
            { label: '无界扩图', value: 'outpaint' },
            { label: '高清放大', value: 'hd_upscale' }
          ]
        }
      ],
      requirementCards: [this.createCard()]
    }
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideClick)
    document.addEventListener('mousemove', this.handleMouseMove)
    const savedTheme = localStorageUtils.getItem('theme')
    if (savedTheme !== null && savedTheme !== '') {
      this.theme = savedTheme
    }
    this.startTaskPolling()
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick)
    document.removeEventListener('mousemove', this.handleMouseMove)
    this.stopTaskPolling()
  },
  computed: {
    // 合并本地队列与后端轮询结果：本地任务在前，去重（通过 taskLogId）他人任务
    displayTaskList() {
      const local = this.localTaskList.map(t => ({ ...t, _source: 'local' }))
      const localLogIds = new Set(this.localTaskList.map(t => t.taskLogId).filter(Boolean))
      const remote = this.taskList
        .filter(t => !localLogIds.has(t.id))
        .map(t => ({ ...t, _source: 'remote' }))
      return [...local, ...remote]
    }
  },
  methods: {
    // 获取功能名称
    getFunctionLabel(value) {
      for (const group of this.functionGroups) {
        const fn = group.options.find(item => item.value === value)
        if (fn) return fn.label
      }
      return '选择功能'
    },
    // 展开/收起功能下拉菜单
    toggleDropdown(cardIndex) {
      const card = this.requirementCards[cardIndex]
      const next = !card.dropdownOpen
      this.closeAllDropdowns()
      this.closeAllRowMenus()
      this.closeAllCountMenus()
      this.closeAllFuncMenus()
      card.dropdownOpen = next
    },
    // 选择功能：切换后重置各行上传数据以匹配新功能的上传规格
    selectFunction(cardIndex, value) {
      const card = this.requirementCards[cardIndex]
      card.selectedFunction = value
      card.dropdownOpen = false
      card.rows.forEach(row => {
        this.$set(row, 'uploads', {})
        this.$set(row, 'galleryImages', [])
      })
    },
    // 关闭所有下拉菜单
    closeAllDropdowns() {
      this.requirementCards.forEach(card => {
        card.dropdownOpen = false
      })
    },
    // 点击外部关闭下拉
    handleOutsideClick() {
      this.closeAllDropdowns()
      this.closeAllRowMenus()
      this.closeAllCountMenus()
      this.closeAllFuncMenus()
    },
    // 鼠标移动：当光标进入某个气泡对自身对称中轴线上下 25px 区域时，显示该表的会话气泡
    handleMouseMove(e) {
      let bubbleEls = this.$refs.bubbles
      if (!bubbleEls) return
      if (!Array.isArray(bubbleEls)) bubbleEls = [bubbleEls]
      bubbleEls.forEach((el, index) => {
        const card = this.requirementCards[index]
        if (!el || !card) return
        const rect = el.getBoundingClientRect()
        // 容器垂直中心即两个气泡的对称中轴线（gap 中线）
        const axisY = rect.top + rect.height / 2
        card.bubblesVisible = Math.abs(e.clientY - axisY) <= 25
      })
    },
    // 弹出文件选择框，选图后用 FileReader 读为本地预览 dataURL，返回 { file, url }
    pickImageFile() {
      return new Promise((resolve) => {
        const input = document.createElement('input')
        input.type = 'file'
        input.accept = 'image/*'
        input.onchange = () => {
          const file = input.files && input.files[0]
          if (!file) {
            resolve(null)
            return
          }
          const reader = new FileReader()
          reader.onload = () => resolve({ file, url: reader.result })
          reader.onerror = () => resolve(null)
          reader.readAsDataURL(file)
        }
        input.click()
      })
    },
    // 上传（本地预览）：columns 模式按列 key 存 { file, url }，提交时才上传 OSS
    async handleUpload(cardIndex, rowIdx, key) {
      const picked = await this.pickImageFile()
      if (!picked) return
      this.$set(this.requirementCards[cardIndex].rows[rowIdx].uploads, key, picked)
    },
    // 多图（gallery）添加（本地预览）：存 { file, url }
    async handleGalleryAdd(cardIndex, rowIdx) {
      const picked = await this.pickImageFile()
      if (!picked) return
      this.requirementCards[cardIndex].rows[rowIdx].galleryImages.push(picked)
    },
    // 移除 gallery 中的某张图
    removeGalleryImage(cardIndex, rowIdx, imgIdx) {
      this.requirementCards[cardIndex].rows[rowIdx].galleryImages.splice(imgIdx, 1)
    },
    // 查看输出图片大图（使用 el-image，支持放大缩小 + ← → 键盘翻页对比）
    handleOutputImageClick(row, clickedIndex) {
      if (!row || !row.outputImages || !row.outputImages.length) return
      const idx = (clickedIndex == null || clickedIndex < 0) ? 0 : clickedIndex
      this.previewList = row.outputImages.slice()
      this.previewStartIndex = idx
      this.previewUrl = row.outputImages[idx]
      this.$nextTick(() => {
        this.$refs.previewImage.clickHandler()
      })
    },
    // 任务列表状态文案
    taskStatusText(task) {
      const map = {
        queued: '排队中',
        running: '生成中',
        done: '已完成',
        error: '失败',
        failed: '失败',
        skipped: '已跳过'
      }
      return map[task.status] || ''
    },
    // type → 功能名映射
    taskTypeLabel(type) {
      const map = {
        'ai/d/t/changeFingerv1': '替换甲片',
        'ai/d/t/changeFingerv2': '替换甲片',
        'ai/d/t/blendImage': '光影溶图',
        'ai/d/t/imagScaling': '无界扩图',
        'ai/d/t/qualityOpt': '高清放大'
      }
      return map[type] || '生成任务'
    },
    // 拉取全局进行中任务（所有用户），映射到左侧任务列表
    async fetchActiveTasks() {
      try {
        const rep = await getActiveTasks({ silent: true })
        const raw = (rep && rep.data && (rep.data.list || rep.data.tasks)) || (rep && rep.data) || []
        const list = Array.isArray(raw) ? raw : []
        this.taskList = list.map(t => ({
          id: t.id,
          taskLogId: t.id,
          funcLabel: this.taskTypeLabel(t.type),
          userName: t.creator_name || t.userName || '',
          status: t.status || 'running',
          startTime: t.start_datetime || t.startTime || ''
        }))
      } catch (e) {
        // 接口未就绪/网络异常时静默失败，不影响生成流程
      }
    },
    // 新增一条本地任务（展开到 localTaskList，立即显示排队）
    pushLocalTask({ funcLabel, roundLabel, cardIndex, rowIdx }) {
      this.localTaskCounter += 1
      const id = `local-${Date.now()}-${this.localTaskCounter}`
      this.localTaskList.push({
        id,
        funcLabel,
        roundLabel,
        cardIndex,
        rowIdx,
        status: 'queued',
        progress: 0,
        taskLogId: null
      })
      return id
    },
    // 按 id 更新本地任务
    updateLocalTask(id, patch) {
      const item = this.localTaskList.find(t => t.id === id)
      if (!item) return
      Object.assign(item, patch)
    },
    // 移除本地任务（完成后立即移除，让后端记录接管或自然消失）
    scheduleRemoveLocalTask(id) {
      const idx = this.localTaskList.findIndex(t => t.id === id)
      if (idx > -1) this.localTaskList.splice(idx, 1)
    },
    startTaskPolling() {
      this.fetchActiveTasks()
      this.taskPollTimer = setInterval(this.fetchActiveTasks, 5000)
    },
    stopTaskPolling() {
      if (this.taskPollTimer) {
        clearInterval(this.taskPollTimer)
        this.taskPollTimer = null
      }
    },
    // 将本地 File 上传到 OSS，返回 URL
    async uploadFileToOSS(file) {
      const ossClient = await getOssClient()
      const ext = file.name.substring(file.name.lastIndexOf('.'))
      const uniqueName = `${Date.now()}_${Math.floor(Math.random() * 10000)}${ext}`
      const result = await ossClient.put('/input/' + uniqueName, file)
      return result.url
    },
    // 组装某功能的调用参数（先将本行 File 上传 OSS 得到 URL）
    async buildTaskParams(card, row) {
      const fn = card.selectedFunction
      if (fn === 'nail_replace') {
        if (!row.uploads.hand || !row.uploads.hand.file || !row.uploads.color || !row.uploads.color.file) {
          throw new Error('请上传手图和色卡')
        }
        const [inputImageUrl, referenceImageUrl] = await Promise.all([
          this.uploadFileToOSS(row.uploads.hand.file),
          this.uploadFileToOSS(row.uploads.color.file)
        ])
        const p = card.funcParams.nail_replace
        return {
          inputImageUrl,
          referenceImageUrl,
          nailShapeEnabled: p.nailShapeEnabled,
          selectedStyle: p.selectedStyle
        }
      }
      // light_blend / outpaint / hd_upscale 均为单图（列 key 为 image）
      if (!row.uploads.image || !row.uploads.image.file) {
        throw new Error('请上传图片')
      }
      const imageUrl = await this.uploadFileToOSS(row.uploads.image.file)
      if (fn === 'outpaint') {
        const p = card.funcParams.outpaint
        return { imageUrl, top: p.top, bottom: p.bottom, left: p.left, right: p.right, feather: p.feather }
      }
      return { imageUrl }
    },
    // 开始批量生成：按 (行, 次数) 立即展开本地队列，再串行运行 N 次
    async startBatch() {
      if (this.batchRunning) return
      this.batchRunning = true
      // 清空上一轮的本地队列
      this.localTaskList = []
      this.fetchActiveTasks()

      // 第一阶段：预先校验并展开本地队列（按行×次数，立即可见）
      const queue = [] // { localId, cardIndex, rowIdx, fn, params }
      for (let ci = 0; ci < this.requirementCards.length; ci++) {
        const card = this.requirementCards[ci]
        const fn = card.selectedFunction
        // 优先用下拉框里的 label（与用户看到的一致），再兜底到 taskTypeLabel
        let funcLabel = this.getFunctionLabel(fn)
        if (!funcLabel || funcLabel === '选择功能') {
          funcLabel = this.taskTypeLabel(fn)
        }
        for (let ri = 0; ri < card.rows.length; ri++) {
          const row = card.rows[ri]
          let params
          try {
            params = await this.buildTaskParams(card, row)
          } catch (e) {
            Message.warning(e.message || '该行上传不完整，已跳过')
            continue
          }
          for (let n = 0; n < row.count; n++) {
            let localId = null
            // 功能名有效时才创建本地任务（兜底文案不污染 UI）
            if (funcLabel && funcLabel !== '生成任务' && funcLabel !== '选择功能') {
              localId = this.pushLocalTask({
                funcLabel,
                roundLabel: row.count > 1 ? `(${n + 1}/${row.count})` : '',
                cardIndex: ci,
                rowIdx: ri
              })
            }
            queue.push({ localId, cardIndex: ci, rowIdx: ri, fn, params })
          }
        }
      }

      // 第二阶段：串行执行，逐条标记 running → done → 完成后立即移除本地项
      try {
        for (const q of queue) {
          const card = this.requirementCards[q.cardIndex]
          const row = card.rows[q.rowIdx]
          row.status = 'running'
          row.progress = 0
          if (q.localId) this.updateLocalTask(q.localId, { status: 'running', progress: 0 })
          try {
            const images = await runBatchTask(q.fn, q.params, (p) => {
              row.progress = Number(p)
              if (q.localId) this.updateLocalTask(q.localId, { progress: Number(p) })
            }, (taskLogId) => {
              // 后端写入后立即绑定 taskLogId，让轮询能去重本地项
              if (q.localId) this.updateLocalTask(q.localId, { taskLogId })
            })
            if (Array.isArray(images)) {
              images.forEach(url => row.outputImages.push(url))
            }
            // 生成完成：结束进度条并切换到已完成状态，否则输出单元格会一直转圈
            row.progress = 100
            row.status = 'done'
            // 任务完成：立即移除本地项，让后端记录（或已结束）接管
            if (q.localId) this.scheduleRemoveLocalTask(q.localId)
            this.fetchActiveTasks()
          } catch (err) {
            console.error('批量生成失败:', err)
            // 失败时结束转圈：有已产出的图则视为完成，否则标记为错误
            row.status = row.outputImages.length ? 'done' : 'error'
            if (q.localId) this.scheduleRemoveLocalTask(q.localId)
            Message.error('生成失败，请检查网络或稍后重试')
          }
        }
      } finally {
        this.batchRunning = false
        this.fetchActiveTasks()
      }
    },
    // 获取功能配置（未配置的功能回退为单图上传、无特殊控件）
    getFuncConfig(fnValue) {
      return this.functionConfig[fnValue] || {
        controls: [],
        uploadSpec: { mode: 'columns', columns: [{ key: 'image', label: '上传图片' }] }
      }
    },
    // 获取上传规格
    getUploadSpec(fnValue) {
      return this.getFuncConfig(fnValue).uploadSpec
    },
    // 上传列宽度：让上传区总宽固定为 300px（= 替换甲片两列），保证「次数」列位置不随功能变化
    uploadColStyle(fnValue) {
      const spec = this.getUploadSpec(fnValue)
      if (spec.mode !== 'columns') return {}
      const n = (spec.columns && spec.columns.length) || 1
      return { width: (300 / n) + 'px' }
    },
    // 该功能是否有后置控件
    hasControls(fnValue) {
      return this.getFuncConfig(fnValue).controls.length > 0
    },
    // 该功能是否包含某个控件
    hasControl(fnValue, name) {
      return this.getFuncConfig(fnValue).controls.indexOf(name) !== -1
    },
    // 创建各功能的选中参数（字段名对齐各原组件，供后续调用直接取用）
    createFuncParams() {
      return {
        nail_replace: { nailShapeEnabled: true, selectedStyle: 'pure' },
        product_retouch: {
          selectedType: '常规类',
          selectedResolution: '2K',
          selectedAspectRatio: '16:9',
          resolutionMenuOpen: false,
          aspectMenuOpen: false
        },
        multi_angle: {
          selectedAngles: ['预设俯视', '预设俯视', '预设俯视', '预设仰视', '预设仰视'],
          cameraParams: [
            { horizontal_angle: 345, vertical_angle: 20, zoom: 5 },
            { horizontal_angle: 345, vertical_angle: 20, zoom: 5 },
            { horizontal_angle: 345, vertical_angle: 20, zoom: 5 },
            { horizontal_angle: 20, vertical_angle: -10, zoom: 5 },
            { horizontal_angle: 20, vertical_angle: -10, zoom: 5 }
          ],
          advancedPanelOpen: false,
          angleMenusOpen: [false, false, false, false, false]
        },
        outpaint: { top: 0, bottom: 0, left: 0, right: 0, feather: 0 },
        product_splice: { selectedResolution: '2K', resolutionMenuOpen: false }
      }
    },
    // 创建一个空白数据行
    createRow() {
      return {
        uploads: {},
        galleryImages: [],
        count: 3,
        status: 'idle',
        progress: 0,
        outputImages: [],
        menuOpen: false,
        countMenuOpen: false
      }
    },
    // 创建一个空白需求表
    createCard() {
      return {
        selectedFunction: 'nail_replace',
        dropdownOpen: false,
        bubblesVisible: false,
        funcParams: this.createFuncParams(),
        rows: [this.createRow()]
      }
    },
    // 灰色气泡：为当前需求表新增一行
    addRow(cardIndex) {
      this.requirementCards[cardIndex].rows.push(this.createRow())
    },
    // 橙色气泡：在当前需求表下方新增一个需求表
    addTable(cardIndex) {
      this.requirementCards.splice(cardIndex + 1, 0, this.createCard())
    },
    // 切换行操作悬浮菜单
    toggleRowMenu(cardIndex, rowIdx) {
      const row = this.requirementCards[cardIndex].rows[rowIdx]
      const next = !row.menuOpen
      this.closeAllRowMenus()
      this.closeAllCountMenus()
      this.closeAllDropdowns()
      this.closeAllFuncMenus()
      row.menuOpen = next
    },
    // 关闭所有行操作菜单
    closeAllRowMenus() {
      this.requirementCards.forEach(card => {
        card.rows.forEach(row => {
          row.menuOpen = false
        })
      })
    },
    // 切换“次数”选择悬浮窗
    toggleCountMenu(cardIndex, rowIdx) {
      const row = this.requirementCards[cardIndex].rows[rowIdx]
      const next = !row.countMenuOpen
      this.closeAllRowMenus()
      this.closeAllCountMenus()
      this.closeAllDropdowns()
      this.closeAllFuncMenus()
      row.countMenuOpen = next
    },
    // 选择次数
    selectCount(cardIndex, rowIdx, value) {
      const row = this.requirementCards[cardIndex].rows[rowIdx]
      row.count = value
      row.countMenuOpen = false
    },
    // 关闭所有“次数”悬浮窗
    closeAllCountMenus() {
      this.requirementCards.forEach(card => {
        card.rows.forEach(row => {
          row.countMenuOpen = false
        })
      })
    },
    // ========== 功能后置控件（与各原组件字段一致） ==========
    // 甲型开关
    toggleNailShape(cardIndex) {
      const p = this.requirementCards[cardIndex].funcParams.nail_replace
      p.nailShapeEnabled = !p.nailShapeEnabled
    },
    // 选择甲片风格
    selectNailStyle(cardIndex, value) {
      this.requirementCards[cardIndex].funcParams.nail_replace.selectedStyle = value
    },
    // 选择产品精修类型
    selectRetouchType(cardIndex, type) {
      this.requirementCards[cardIndex].funcParams.product_retouch.selectedType = type
    },
    // 选择图像大小（产品精修 / 产品拼接共用）
    selectFuncResolution(cardIndex, fnKey, value) {
      const p = this.requirementCards[cardIndex].funcParams[fnKey]
      p.selectedResolution = value
      p.resolutionMenuOpen = false
    },
    // 选择高宽比（产品精修）
    selectAspectRatio(cardIndex, value) {
      const p = this.requirementCards[cardIndex].funcParams.product_retouch
      p.selectedAspectRatio = value
      p.aspectMenuOpen = false
    },
    // 选择画面角度（多角度）：同步更新对应相机参数
    selectAngle(cardIndex, angIdx, value) {
      const p = this.requirementCards[cardIndex].funcParams.multi_angle
      this.$set(p.selectedAngles, angIdx, value)
      const preset = this.angleParamsMap[value]
      if (preset) this.$set(p.cameraParams, angIdx, { ...preset })
      this.$set(p.angleMenusOpen, angIdx, false)
    },
    // 高级选项（多角度）：本轮仅切换状态
    toggleAdvanced(cardIndex) {
      const p = this.requirementCards[cardIndex].funcParams.multi_angle
      p.advancedPanelOpen = !p.advancedPanelOpen
    },
    // 切换某个角度下拉
    toggleAngleMenu(cardIndex, angIdx) {
      const p = this.requirementCards[cardIndex].funcParams.multi_angle
      const next = !p.angleMenusOpen[angIdx]
      this.closeAllDropdowns()
      this.closeAllRowMenus()
      this.closeAllCountMenus()
      this.closeAllFuncMenus()
      this.$set(p.angleMenusOpen, angIdx, next)
    },
    // 切换功能后置下拉（图像大小 / 高宽比）
    toggleFuncMenu(cardIndex, fnKey, menuKey) {
      const p = this.requirementCards[cardIndex].funcParams[fnKey]
      const next = !p[menuKey]
      this.closeAllDropdowns()
      this.closeAllRowMenus()
      this.closeAllCountMenus()
      this.closeAllFuncMenus()
      p[menuKey] = next
    },
    // 关闭所有功能后置下拉
    closeAllFuncMenus() {
      this.requirementCards.forEach(card => {
        const fp = card.funcParams
        if (!fp) return
        if (fp.product_retouch) {
          fp.product_retouch.resolutionMenuOpen = false
          fp.product_retouch.aspectMenuOpen = false
        }
        if (fp.product_splice) fp.product_splice.resolutionMenuOpen = false
        if (fp.multi_angle) {
          fp.multi_angle.angleMenusOpen = fp.multi_angle.angleMenusOpen.map(() => false)
        }
      })
    },
    // 行操作：删除该行（若需求表已无数据行则移除该表，且至少保留一个需求表）
    handleRowDelete(cardIndex, rowIdx) {
      const card = this.requirementCards[cardIndex]
      card.rows.splice(rowIdx, 1)
      if (card.rows.length === 0) {
        if (this.requirementCards.length > 1) {
          this.requirementCards.splice(cardIndex, 1)
        } else {
          card.rows.push(this.createRow())
        }
      }
    },
    // 行操作：保存全部（逐张下载当前行所有输出图片）
    async handleRowSave(cardIndex, rowIdx) {
      this.closeAllRowMenus()
      const row = this.requirementCards[cardIndex].rows[rowIdx]
      const images = row && row.outputImages ? row.outputImages : []
      if (!images.length) {
        Message.warning('该行还没有生成图片')
        return
      }
      for (let i = 0; i < images.length; i++) {
        try {
          const url = images[i]
          // 跨域 OSS 链接直接用 a[download] 会被浏览器忽略并变成页面跳转（触发"离开网站"提示）
          // 故先 fetch 为 Blob，再用同源 blob: URL 下载，避免跳转
          const response = await fetch(url)
          const blob = await response.blob()
          const blobUrl = window.URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = blobUrl
          a.download = `batch_${cardIndex}_${rowIdx}_${i + 1}.png`
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          window.URL.revokeObjectURL(blobUrl)
        } catch (e) {
          console.error('下载失败', e)
        }
        // 间隔避免浏览器拦截连续下载
        await new Promise(resolve => setTimeout(resolve, 200))
      }
      Message.success(`已保存 ${images.length} 张图片`)
    },
    // 行操作：重新生成（清空输出图片，用原上传图+参数重跑）
    async handleRowRegenerate(cardIndex, rowIdx) {
      this.closeAllRowMenus()
      const card = this.requirementCards[cardIndex]
      const row = card.rows[rowIdx]
      row.outputImages = []
      row.status = 'idle'
      row.progress = 0
      await this.submitRowOnce(card, row)
    },
    // 通用：对单行执行一次完整生成（buildTaskParams + 按 count 次运行）
    async submitRowOnce(card, row) {
      const fn = card.selectedFunction
      let params
      try {
        params = await this.buildTaskParams(card, row)
      } catch (e) {
        Message.warning(e.message || '该行上传不完整，无法生成')
        return
      }
      const cardIndex = this.requirementCards.indexOf(card)
      const rowIdx = card.rows.indexOf(row)
      // 优先用下拉框里的 label，再兜底到 taskTypeLabel
      let funcLabel = this.getFunctionLabel(fn)
      if (!funcLabel || funcLabel === '选择功能') {
        funcLabel = this.taskTypeLabel(fn)
      }
      // 按次数展开本地队列
      const localIds = []
      for (let n = 0; n < row.count; n++) {
        let localId = null
        if (funcLabel && funcLabel !== '生成任务' && funcLabel !== '选择功能') {
          localId = this.pushLocalTask({
            funcLabel,
            roundLabel: row.count > 1 ? `(${n + 1}/${row.count})` : '',
            cardIndex,
            rowIdx
          })
        }
        localIds.push(localId)
      }
      row.status = 'running'
      row.progress = 0
      try {
        for (let n = 0; n < row.count; n++) {
          const localId = localIds[n]
          if (localId) this.updateLocalTask(localId, { status: 'running', progress: 0 })
          try {
            const images = await runBatchTask(fn, params, (p) => {
              row.progress = Number(p)
              if (localId) this.updateLocalTask(localId, { progress: Number(p) })
            }, (taskLogId) => {
              if (localId) this.updateLocalTask(localId, { taskLogId })
            })
            if (Array.isArray(images)) {
              images.forEach(url => row.outputImages.push(url))
            }
          } catch (err) {
            console.error('生成失败:', err)
            Message.error('生成失败，请检查网络或稍后重试')
          }
          if (localId) this.scheduleRemoveLocalTask(localId)
          this.fetchActiveTasks()
        }
        row.status = 'done'
        row.progress = 100
      } catch (err) {
        console.error('生成失败:', err)
        row.status = 'error'
        Message.error('生成失败，请检查网络或稍后重试')
      }
    },
    // 脚本功能 - 跳转到视频脚本生成页面
    handleScriptClick() {
      this.$router.push({ path: '/index/morejoyassistant_script' })
    },
    // 反推功能（占位）
    handleReverseClick() {
      Message.warning('o(*＾▽＾*)ブ开发者正在开发中,敬请期待😋!')
    },
    // 灵感功能（占位）
    handleInspirationClick() {
      Message.warning('o(*＾▽＾*)ブ开发者正在开发中,敬请期待😋!')
    },
    // 快捷键功能（占位）
    handleShortcutClick() {
      Message.info('快捷键说明：\nCtrl + Enter: 发送消息\nCtrl + V: 粘贴图片')
    },
    // 切换主题
    toggleTheme() {
      this.theme = !this.theme
      localStorageUtils.setItem('theme', this.theme)
      Message.success(this.theme ? '已切换到浅色模式' : '已切换到深色模式')
    }
  }
}
</script>

<style lang="less" scoped>
@import "@/style/common.less";
@import "@/assets/fonts/style.css";
@import "@/assets/font_sczlgzino/iconfont.css";

.batch-generation-center {
  display: flex;
  width: 100vw;
  flex-shrink: 0;
  height: calc(100vh - 95px);
  overflow: hidden;
  box-sizing: border-box;
}

/* ========== 精简侧边栏 ========== */
.slim-sidebar {
  width: 80px;
  background: #fff;
  border-right: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.05);
  flex-shrink: 0;

  .sidebar-middle {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 30px;
    align-items: center;
    justify-content: center;
  }

  .sidebar-bottom {
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
  }

  .nav-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    padding: 12px 0;
    cursor: pointer;
    transition: all 0.3s;
    border-radius: 8px;
    width: 60px;

    .iconfont {
      font-size: 24px;
      color: #666;
      transition: all 0.3s;
    }

    .nav-icon {
      width: 24px;
      height: 24px;
      color: #666;
      transition: all 0.3s;
    }

    .nav-label {
      font-size: 12px;
      color: #999;
      transition: all 0.3s;
    }

    &:hover {
      background: #f5f7fa;

      .iconfont {
        color: @morejoy;
      }

      .nav-icon {
        color: @morejoy;
      }

      .nav-label {
        color: @morejoy;
      }
    }
  }
}

/* ========== 内容区域 ========== */
.batch-content {
  flex: 1;
  display: flex;
  min-width: 0;
  padding: 24px 40px;
  box-sizing: border-box;
}

/* ========== 通用标题（居中） ========== */
.section-title {
  font-size: 18px;
  font-weight: 600;
  color: @font_black;
  text-align: center;
  margin-bottom: 16px;
}

/* ========== 左侧：任务列表 ========== */
.task-list-section {
  width: 20%;
  min-width: 280px;
  max-width: 420px;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #ededed;
  padding-right: 20px;
}

.task-list-body {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.task-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.task-empty-icon {
  margin-bottom: 10px;
}

.task-empty-text {
  font-size: 15px;
  color: #444;
  font-weight: 500;
}

.task-empty-subtext {
  font-size: 12px;
  color: #bbb;
}

/* 任务列表（当前会话的批量队列） */
.task-list-body.has-tasks {
  align-items: stretch;
  justify-content: flex-start;
  overflow-y: auto;
}

.task-items {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.task-item {
  padding: 12px 14px;
  border: 1px solid #ededed;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.task-item-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.task-item-name {
  font-size: 14px;
  font-weight: 600;
  color: @font_black;
}

.task-item-round {
  display: inline-block;
  margin-left: 4px;
  font-size: 11px;
  font-weight: 500;
  color: @morejoy;
  opacity: 0.85;
}

.task-item-progress {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
}

.task-item-progress-bar {
  flex: 1;
  height: 6px;
  background: #f0f0f0;
  border-radius: 3px;
  overflow: hidden;
}

.task-item-progress-fill {
  height: 100%;
  background: @morejoy;
  border-radius: 3px;
  transition: width 0.25s;
}

.task-item-progress-num {
  font-size: 12px;
  color: @morejoy;
  font-weight: 600;
  min-width: 36px;
  text-align: right;
}

.task-item-status {
  font-size: 12px;
  padding: 2px 10px;
  border-radius: 10px;
  background: #f2f3f5;
  color: #888;
}

.task-item.is-running .task-item-status {
  background: rgba(252, 119, 22, 0.12);
  color: @morejoy;
}

.task-item.is-done .task-item-status {
  background: rgba(45, 190, 96, 0.12);
  color: #2dbe60;
}

.task-item.is-error .task-item-status,
.task-item.is-skipped .task-item-status {
  background: rgba(230, 69, 69, 0.1);
  color: #e64545;
}

.task-item-bar {
  height: 6px;
  border-radius: 3px;
  background: #f0f0f0;
  overflow: hidden;
}

.task-item-bar-fill {
  height: 100%;
  background: @morejoy;
  border-radius: 3px;
  transition: width 0.3s;
}

.task-item.is-done .task-item-bar-fill {
  background: #2dbe60;
}

.task-item-meta {
  margin-top: 6px;
  font-size: 12px;
  color: #aaa;
  display: flex;
  justify-content: space-between;
  gap: 8px;
}

/* ========== 右侧：需求表 ========== */
.requirement-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.requirement-body {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  padding: 20px 300px;
}

/* 用自动外边距实现“表少时垂直居中、表多时可完整滚动到顶部”，
   避免 justify-content:center 在内容溢出时裁切顶部导致第一个表格被遵盖 */
.requirement-body .req-table:first-child {
  margin-top: auto;
}
.requirement-body .req-table:last-child {
  margin-bottom: auto;
}

/* ========== 需求表格 ========== */
.req-table {
  border: 1px solid #ececec;
  border-radius: 12px;
  margin-bottom: 20px;
  position: relative;
  background: #fff;
  /* 柔和阴影，提升层次感 */
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12), 0 1px 3px rgba(0, 0, 0, 0.04);
  transition: box-shadow 0.25s ease, transform 0.25s ease;
}

/* 第一行：编号 + 功能选择 + 定制按钮 */
.req-table-header {
  display: flex;
  align-items: center;
  padding: 14px 20px;
  gap: 16px;
  border-bottom: 1px solid #ededed;
}

.req-number {
  color: @morejoy;
  font-size: 16px;
  font-weight: 700;
  flex-shrink: 0;
}

.req-function-select {
  flex-shrink: 0;
  position: relative;
}

.func-select {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 160px;
  padding: 6px 16px;
  border: 1px solid #dcdcdc;
  border-radius: 18px;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s;
  user-select: none;

  &:hover,
  &.is-open {
    border-color: @morejoy;
  }

  .func-select-label {
    font-size: 13px;
    color: #333;
  }

  .func-select-arrow {
    font-size: 12px;
    color: #999;
    font-style: normal;
    transition: transform 0.2s;
    margin-left: 8px;
  }

  &.is-open .func-select-arrow {
    transform: rotate(180deg);
  }
}

.func-dropdown-menu {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  width: 160px;
  max-height: 320px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 10px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  padding: 6px;
  z-index: 100;
}

.func-dropdown-group-title {
  padding: 8px 12px 4px;
  font-size: 12px;
  color: #bbb;
  font-weight: 600;
}

.func-dropdown-item {
  padding: 8px 12px;
  font-size: 13px;
  color: #555;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s;

  &:hover {
    background: #f5f5f5;
  }

  &.is-selected {
    background: @morejoyBack;
    color: @morejoy;
    font-weight: 500;
  }
}

/* ========== 功能后置控件区 ========== */
.req-func-controls {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  flex: 1;
  min-width: 0;
}

/* 开关（甲型） */
.fc-toggle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  user-select: none;

  .fc-toggle-label {
    font-size: 13px;
    color: #555;
  }

  .fc-toggle-switch {
    position: relative;
    width: 38px;
    height: 20px;
    border-radius: 10px;
    background: #dcdcdc;
    transition: background 0.2s;

    .fc-toggle-knob {
      position: absolute;
      top: 2px;
      left: 2px;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background: #fff;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
      transition: transform 0.2s;
    }
  }

  &.is-on .fc-toggle-switch {
    background: @morejoy;

    .fc-toggle-knob {
      transform: translateX(18px);
    }
  }
}

/* 三选一 tab 组（甲片风格 / 精修类型） */
.fc-tabs {
  display: inline-flex;
  align-items: center;
  padding: 3px;
  background: #f2f3f5;
  border-radius: 14px;
  gap: 2px;

  .fc-tab {
    padding: 4px 12px;
    font-size: 13px;
    color: #666;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.2s;
    white-space: nowrap;

    &:hover {
      color: @morejoy;
    }

    &.is-active {
      background: @morejoy;
      color: #fff;
      font-weight: 500;
    }
  }
}

/* 后置下拉（图像大小 / 高宽比 / 画面角度） */
.fc-dropdown {
  position: relative;
  display: inline-flex;
}

.fc-dropdown-trigger {
  display: inline-flex;
  align-items: center;
  padding: 5px 12px;
  font-size: 13px;
  color: #555;
  background: #fff;
  border: 1px solid #dcdcdc;
  border-radius: 14px;
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
  transition: all 0.2s;

  &:hover,
  &.is-open {
    border-color: @morejoy;
    color: @morejoy;
  }

  .fc-arrow {
    font-style: normal;
    font-size: 11px;
    color: #999;
    margin-left: 6px;
    transition: transform 0.2s;
  }

  &.is-open .fc-arrow {
    transform: rotate(180deg);
  }
}

.fc-menu {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  min-width: 100%;
  max-height: 260px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 10px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  padding: 6px;
  z-index: 100;
}

.fc-menu-item {
  padding: 7px 14px;
  font-size: 13px;
  color: #555;
  border-radius: 8px;
  text-align: center;
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;

  &:hover {
    background: #f5f5f5;
    color: @morejoy;
  }

  &.is-active {
    background: @morejoy;
    color: #fff;
  }
}

/* 画面角度：多个下拉横排 */
.fc-angles {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

/* 普通功能按钮（高级选项） */
.fc-btn {
  padding: 5px 14px;
  font-size: 13px;
  color: #555;
  background: #fff;
  border: 1px solid #dcdcdc;
  border-radius: 14px;
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
  transition: all 0.2s;

  &:hover {
    border-color: @morejoy;
    color: @morejoy;
  }

  &.is-active {
    background: @morejoy;
    border-color: @morejoy;
    color: #fff;
  }
}

/* 无界扩图数值输入 */
.fc-outpaint {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.fc-num {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: #666;

  input {
    width: 52px;
    padding: 4px 6px;
    border: 1px solid #dcdcdc;
    border-radius: 8px;
    font-size: 13px;
    text-align: center;
    outline: none;
    transition: border-color 0.2s;

    &:focus {
      border-color: @morejoy;
    }
  }
}

/* 需遮罩标记（列标题 + 上传框角标） */
.mask-tag {
  margin-left: 4px;
  font-size: 11px;
  color: @morejoy;
}

.mask-badge {
  position: absolute;
  top: 4px;
  right: 4px;
  padding: 1px 6px;
  font-size: 10px;
  color: #fff;
  background: @morejoy;
  border-radius: 8px;
}

/* 已上传缩略图（columns 模式） */
.upload-thumb {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  object-fit: cover;
}

/* 多图（gallery）上传 */
.req-cell-upload.req-cell-gallery {
  width: 300px;
  min-width: 0;
  flex: none;
}

.gallery-box {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}

.gallery-thumb {
  position: relative;
  width: 72px;
  height: 72px;
  border-radius: 10px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .gallery-remove {
    position: absolute;
    top: 2px;
    right: 2px;
    width: 16px;
    height: 16px;
    line-height: 14px;
    text-align: center;
    font-size: 12px;
    color: #fff;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 50%;
    cursor: pointer;
  }
}

.upload-box.gallery-add {
  width: 72px;
  height: 72px;
}

/* 表格主体：列标题行 + 数据行（带竖直分隔线） */
.req-table-body {
  display: flex;
  flex-direction: column;
}

.req-row {
  display: flex;
  position: relative;
}

/* 数据行之间的分隔线 */
.req-row-data + .req-row-data {
  border-top: 1px solid #ededed;
}

.req-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid #ededed;
  box-sizing: border-box;
}

/* 列标题行 */
.req-row-titles .req-cell {
  padding: 10px 12px;
  font-size: 13px;
  color: #999;
  font-weight: 400;
}

/* 数据行单元格内边距 */
.req-row-data .req-cell {
  padding: 16px 16px 20px;
}

/* 列宽 */
.req-cell-upload {
  width: 150px;
  flex-shrink: 0;
}

.req-cell-count {
  width: 100px;
  flex-shrink: 0;
}

.req-cell-output {
  flex: 1;
  min-width: 0;
  border-right: none;
}

/* ========== 行操作按钮（表格外右侧，垂直居中） ========== */
.req-row-action {
  position: absolute;
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
  /* 用 padding 而非 margin 桥接行与按钮的命中区，避免鼠标移向按钮时因空隙丢失 :hover 导致按钮消失 */
  padding-left: 12px;
  z-index: 20;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s;
}

/* 鼠标悬停在该行时显示行操作按钮；菜单展开时保持显示 */
.req-row-data:hover .req-row-action,
.req-row-action.is-menu-open {
  opacity: 1;
  visibility: visible;
}

.row-menu-btn {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #fff;
  border: 1px solid #e5e5e5;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);

  .dot {
    width: 3.5px;
    height: 3.5px;
    border-radius: 50%;
    background: #999;
    transition: background 0.2s;
  }

  &:hover,
  &.is-open {
    border-color: @morejoy;

    .dot {
      background: @morejoy;
    }
  }
}

/* 行操作悬浮菜单 */
.row-menu {
  position: absolute;
  top: 50%;
  left: calc(100% + 8px);
  transform: translateY(-50%);
  min-width: 110px;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 10px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  padding: 6px;
  z-index: 100;
}

.row-menu-item {
  padding: 8px 14px;
  font-size: 13px;
  color: #555;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;

  &:hover {
    background: #f5f5f5;
    color: @morejoy;
  }
}

/* 上传框 */
.upload-box {
  position: relative;
  width: 110px;
  height: 110px;
  border: 2px dashed #dcdcdc;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.25s;
  background: #fff;

  &:hover {
    border-color: @morejoy;
    background: rgba(252, 119, 22, 0.03);
  }

  .upload-plus {
    font-size: 32px;
    color: #ccc;
    line-height: 1;
    font-weight: 300;
  }

  &:hover .upload-plus {
    color: @morejoy;
  }
}

/* 次数标签 */
.count-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 5px 16px;
  background: @morejoy;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  border-radius: 14px;
  cursor: pointer;
  user-select: none;
  transition: all 0.15s;
}

.count-badge:hover,
.count-badge.is-open {
  box-shadow: 0 2px 8px rgba(252, 119, 22, 0.35);
  filter: brightness(1.05);
}

/* “次数”选择悬浮窗 */
.count-select {
  position: relative;
  display: inline-flex;
}

.count-menu {
  position: absolute;
  top: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  min-width: 88px;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 10px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  padding: 6px;
  z-index: 100;
}

.count-menu-item {
  padding: 7px 14px;
  font-size: 13px;
  color: #555;
  border-radius: 8px;
  text-align: center;
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;

  &:hover {
    background: #f5f5f5;
    color: @morejoy;
  }

  &.is-active {
    background: @morejoy;
    color: #fff;
  }
}

/* 输出图片区域 */
.output-progress {
  display: flex;
  align-items: center;
  gap: 12px;
}

.output-spinner {
  position: relative;
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.output-spinner-ring {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 3px solid rgba(252, 119, 22, 0.2);
  border-top-color: @morejoy;
  animation: batch-spin 0.9s linear infinite;
}

.output-spinner-num {
  position: relative;
  font-size: 12px;
  font-weight: 600;
  color: @morejoy;
}

@keyframes batch-spin {
  to {
    transform: rotate(360deg);
  }
}

.output-progress-text {
  font-size: 13px;
  color: @morejoy;
}

.output-gallery {
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
  align-items: center;
}

.output-thumb {
  width: 110px;
  height: 110px;
  flex-shrink: 0;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #eee;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.output-hint {
  font-size: 13px;
  color: #bbb;
}

.output-hint-error {
  color: #e64545;
}

/* ========== 底部操作栏：开始批量生成 ========== */
.batch-footer {
  display: flex;
  justify-content: center;
  padding: 18px 4px 6px;
}

.batch-start-btn {
  min-width: 360px;
  padding: 13px 40px;
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  background: @morejoy;
  border: none;
  border-radius: 24px;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 4px 14px rgba(252, 119, 22, 0.3);

  &:hover:not(:disabled) {
    filter: brightness(1.05);
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    box-shadow: none;
  }
}

/* ========== 悬停聊天气泡按钮（上灰下橙，表格左侧外部） ========== */
.req-hover-bubbles {
  position: absolute;
  left: -40px;
  /* 容器高度 = 30 + 4(gap) + 30 = 64px，居中下移 32px 使两个气泡的对称轴（gap 中线）与表格最下框线同高 */
  bottom: -34px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.2s;
  z-index: 10;
}

/* 鼠标进入气泡自身对称中轴线上下 25px 区域时显示会话气泡 */
.req-hover-bubbles.is-visible {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
}

.bubble-btn {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);

  span {
    font-size: 16px;
    font-weight: 700;
    line-height: 1;
  }

  &:hover {
    transform: scale(1.12);
  }
}

/* 灰色气泡（上）：尖角在右下，朝向表格 */
.bubble-gray {
  background: #b0b0b0;
  color: #fff;
  border-radius: 50% 50% 4px 50%;
}

/* 橙色气泡（下）：尖角在右上，朝向表格，与灰色气泡沿水平轴镜像对称 */
.bubble-orange {
  background: @morejoy;
  color: #fff;
  border-radius: 50% 4px 50% 50%;
}
</style>
